import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getMeristemContext } from "src/utils/meristemContext";

export interface DeviceInformationState {
  device_brand: string;
  device_family: string;
  device_is_mobile: boolean;
  device_os: string;
}

const extractData = (data: DeviceInformationState) => {
  return {
    device_brand: data.device_brand,
    device_family: data.device_family,
    device_is_mobile: data.device_is_mobile,
    device_os: data.device_os,
  };
};

const deviceInformationSlice = createSlice({
  name: "deviceInformation",
  initialState: extractData(getMeristemContext()),
  reducers: {
    setDeviceInformation(state, action: PayloadAction<DeviceInformationState>) {
      return extractData(action.payload);
    },
  },
});

export const { setDeviceInformation } = deviceInformationSlice.actions;

export default deviceInformationSlice.reducer;
